export enum DashboardAreaSubjectEnum {
  AnalysisReports = 0,
  Recommendations = 1,
  LiveVideos = 2,
  Ebooks = 3,
  SpeficicProgram = 4,
  EnrolledPrograms = 5,
  AvailablePrograms = 6,
  EnrolledCourses = 7,
  AvailableCourses = 8,
  EnrolledJourneys = 9,
  AvailableJourneys = 10,
  EnrolledMasterClasses = 11,
  AvailableMasterClasses = 12,
  PracticeExams = 13,
}
